module.exports = __webpack_public_path__ + "static/img/aboutUs20.9f54651.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs20.jpg
// module id = 1372
// module chunks = 1